/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Supported Access Type.
 */
export enum AccessType {
  ADMIN = 'admin',
  BASIC = 'basic',
}
